export type ShapeId = 'square' | 'diamond' | 'hourglass' | 'rectangle' | 'heart';

export interface ShapeDefinition {
  id: ShapeId;
  size: number;
  mask: boolean[][];
}

function createMask(rows: string[]): boolean[][] {
  return rows.map(row => row.split('').map(c => c === '#'));
}

const SQUARE: ShapeDefinition = {
  id: 'square',
  size: 7,
  mask: createMask([
    '#######',
    '#######',
    '#######',
    '#######',
    '#######',
    '#######',
    '#######',
  ]),
};

const DIAMOND: ShapeDefinition = {
  id: 'diamond',
  size: 7,
  mask: createMask([
    '..###..',
    '.#####.',
    '#######',
    '#######',
    '#######',
    '.#####.',
    '..###..',
  ]),
};

const HOURGLASS: ShapeDefinition = {
  id: 'hourglass',
  size: 7,
  mask: createMask([
    '#######',
    '.#####.',
    '..###..',
    '..###..',
    '..###..',
    '.#####.',
    '#######',
  ]),
};

const RECTANGLE: ShapeDefinition = {
  id: 'rectangle',
  size: 7,
  mask: createMask([
    '.#####.',
    '.#####.',
    '.#####.',
    '.#####.',
    '.#####.',
    '.#####.',
    '.#####.',
  ]),
};

const HEART: ShapeDefinition = {
  id: 'heart',
  size: 7,
  mask: createMask([
    '.##.##.',
    '#######',
    '#######',
    '.#####.',
    '..###..',
    '...#...',
    '.......',
  ]),
};

export const SHAPES: Record<ShapeId, ShapeDefinition> = {
  square: SQUARE,
  diamond: DIAMOND,
  hourglass: HOURGLASS,
  rectangle: RECTANGLE,
  heart: HEART,
};

export function getShape(id: ShapeId): ShapeDefinition {
  return SHAPES[id];
}
